import {Injectable} from '@angular/core';
import {MedicalPainDataService} from './medicalPainData.service';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {MedicalRecordPainModel} from '../../../api/model/medicalRecordPain.model';
import {MedicalRecordPainConverter} from '../../../api/converter/medicalRecordPain.converter';

@Injectable({providedIn: 'root'})
export class MedicalPainDataServiceAdapter
    extends AbstractDataServiceDtoAdapter<MedicalRecordPainModel, MedicalRecordPainConverter> {
    constructor(dataService: MedicalPainDataService, converter: MedicalRecordPainConverter) {
        super(dataService, converter);
    }
    newStoredEntityInstance(): MedicalRecordPainModel {
        return new MedicalRecordPainModel();
    }
}
